import { reducers } from '@smorder/logic';

import notificationReducer from './notification.reducers';
import navigatorReducer from './navigator.reducers';
import orderReducer from './order.reducers';
import appReducer from './app.reducers';
import alertReducer from './alert.reducers';
import signageReducer from './signage.reducers';

const appReducers = {
  ...reducers,
  notification: notificationReducer,
  navigator: navigatorReducer,
  orders: orderReducer,
  app: appReducer,
  alert: alertReducer,
  signage: signageReducer,
};

export default appReducers;
